import(/* webpackMode: "eager" */ "/app/apps/web/src/app/login/page.tsx");
